const actions = {
    GET_MOV_AUX: 'GET_MOV_AUX',
    UPDATE_MOVS_AUX: 'UPDATE_MOVS_AUX',
    SAVE_MOV_AUX: 'SAVE_MOV_AUX',
    UPDATE_MOV_AUX_REQUEST: 'UPDATE_MOV_AUX_REQUEST',
    UPDATE_MOV_AUX_SUCCESS: 'UPDATE_MOV_AUX_SUCCESS',
    DELETE_SOFT_MOX_AUX: 'DELETE_SOFT_MOX_AUX',
    GET_INFORMES_MOV_AUX_REQUEST: 'GET_INFORMES_MOV_AUX_REQUEST',
    GET_INFORMES_MOV_AUX_SUCCESS: 'GET_INFORMES_MOV_AUX_SUCCESS',

    SET_PAGINATION_MOVS_INFO: 'SET_PAGINATION_MOVS_INFO',
    SET_RANGO: 'SET_RANGO',

    getMovsAux: (query) => ({
        type: actions.GET_MOV_AUX,
        query
    }),
    saveMovAux: (movCajaAux, history) => ({ 
        type: actions.SAVE_MOV_AUX, 
        movCajaAux, history
    }),
    updateMovAux: (id, info) => ({ 
        type: actions.UPDATE_MOV_AUX_REQUEST, id, info
    }),
    deleteSoftMovAux: id => ({ 
        type: actions.DELETE_SOFT_MOX_AUX, id 
    }),

    getInformesMovAux: (startDate, endDate) => ({ type: actions.GET_INFORMES_MOV_AUX_REQUEST, startDate, endDate }),
};
export default actions;